export default __webpack_public_path__ + "static/DMMono-Regular-0e21074ee2d22a5926f3794c1644d50e.woff";